import React from "react"
import styled from "styled-components"
import { fontSize, responsive, colors, fontWeight } from "buoy-theme"
import { Arrow, Paragraph } from "buoy-core"
import Check from "../../../../completion/images/Check"
import SubsectionArrow from "./SubsectionArrow"

const TitleContainer = styled.button`
  ${fontSize("bodyMain")};
  background: white;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 32px 24px;
  border: none;
  background: none;
  ${responsive("padding", "32px 24px", "32px 24px", "24px", "24px", "24px")};
  ${responsive(
    "border-bottom",
    "none",
    "none",
    `1px solid ${colors.neutralLightest}`,
    `1px solid ${colors.neutralLightest}`,
    `1px solid ${colors.neutralLightest}`
  )};
  opacity: ${props => (props.selected || props.noDim ? "1" : "0.6")};
  transition: opacity 0.25s ease;
  cursor: pointer;
`

const DetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`

const CheckContainer = styled.div`
  position: absolute;
  align-self: center;
  right: 24px;
`

const Bold = styled.strong`
  ${fontSize("bodyLarge")};
  font-weight: ${fontWeight.regular};
`

const Icon = styled.div`
  font-size: 28px;
  border-radius: 50%;
  background-color: ${colors.neutral};
  color: white;
  ${responsive("height", "64px", "64px", "54px", "54px", "54px")};
  ${responsive("min-width", "64px", "64px", "54px", "54px", "54px")};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px 0 0;
  cursor: pointer;
`

const DashboardArrow = styled(SubsectionArrow)`
  ${responsive("display", "none", "none", "block", "block", "block")};
  margin-left: auto;
`

const Title = ({
  name,
  selected,
  isself,
  onClick,
  noDim,
  dashboard,
  noIcon,
}) => (
  <TitleContainer noDim={noDim} onClick={onClick} selected={selected}>
    <Icon>{name.charAt(0)}</Icon>
    <DetailColumn>
      <Bold>{name}</Bold>
      <Paragraph color="neutral" margin="0">
        {isself ? "Primary profile" : "Secondary profile"}
      </Paragraph>
    </DetailColumn>
    {dashboard && (
      <DashboardArrow>
        <Arrow />
      </DashboardArrow>
    )}
    {noDim &&
      selected && (
        <CheckContainer>
          <Check color="primary" />
        </CheckContainer>
      )}
  </TitleContainer>
)

export { Title as default, TitleContainer, Bold, Icon, DetailColumn }



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/Title.js